var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "back-button-container" }, [
    _c(
      "a",
      {
        attrs: {
          href: "/?back",
          tabindex: "0",
          "aria-label": "go to previous screen"
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.back($event)
          }
        }
      },
      [
        _vm.showIcon
          ? _c("BaseIcon", {
              staticClass: "size--modular",
              attrs: { icon: "backChevron", isCustom: true, size: "lg" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.useTitle))])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ba632e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba632e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseBackButton.vue
// module id = null
// module chunks = 